export default __webpack_public_path__ + "static/media/payout.e0e9dc75.svg";